import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { PictureWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-picture.sass');

const FieldModulesLoader = require('_common/platform/jsx/mixins/FieldModulesLoader');

FieldModulesLoader.addModules({
    'pdc-widget-resource-manager/src/ts/react/ResourceBrowser': require('bundle-loader?lazy!pdc-widget-resource-manager/src/ts/react/ResourceBrowser')
});

export class PictureWidget extends WidgetBase {
    public static _name: string = 'Picture';
    public static moduleName: string = 'pdc-widget-picture';
    public static icon: string = 'picture';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-picture'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(PictureWidget);
